import { useState } from "react";
import { PassiveIncomeSimulatorCard } from "./components/PassiveIncomeSimulatorCard";
import { PassiveIncomeSimulatorResponse } from "./components/PassiveIncomeSimulatorResponse";

export default function CalculadoraDeRenda() {
  const [results, setResults] = useState<ResultsTypeRenda | null>(null);

  return (
    <>
      <PassiveIncomeSimulatorCard setResults={setResults} />
      {results && <PassiveIncomeSimulatorResponse results={results} />}
    </>
  );
}
